import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className="thanks-page">
      <div className="thanks-container">
        <h1>404</h1>
        <p>Page not found.</p>
        <p>
          <Link to="/" className="btn">Back to home</Link>
        </p>
      </div>
    </div>
  );
}

export default NotFound;
